import { motion } from 'framer-motion'
import { css } from '@emotion/react'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import ResetIcon from '@groovehq/internal-design-system/lib/assets/icons/Reset'
import { styles as menuStyles } from '@groovehq/internal-design-system/lib/components/Menu/Menu.styles'

const variants = {
  stopped: {
    rotate: 360,
    transition: { ease: 'linear' },
  },
  refreshing: {
    rotate: [0, 360],
    transition: { duration: 1, repeat: Infinity, ease: 'linear' },
  },
}

const View = ({ doRefreshSearches, isRefreshingSearches }) => {
  return (
    <Button
      type="icon"
      size="small"
      onClick={doRefreshSearches}
      css={menuStyles.controlIconButton}
    >
      <motion.div
        initial="stopped"
        animate={isRefreshingSearches ? 'refreshing' : 'stopped'}
        variants={variants}
        css={css`
          transform-origin: 10px 11px;
          margin-top: -1px;
        `}
      >
        <ResetIcon />
      </motion.div>
    </Button>
  )
}

export default View
